export type InitialValues = {
    file: File[];
    email?: string;
};

export const initialValues: InitialValues = {
    file: [],
    email: '',
};
